import React, { useEffect } from "react";
import {
  useGetAllChannelsQuery,
  useDeleteChannelMutation,
} from "../../services/modules/channel";


import { FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearchTerm,
  openDeleteModal,
  closeDeleteModal,
} from "../../store/video";

const VideoList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { searchTerm, isDeleteModalOpen, selectedVideoId } = useSelector(
    (state) => state.video
  );

  const { data, isLoading, refetch } = useGetAllChannelsQuery({
    page: 1,
    pageSize: 50,
    title: "",
  });
 console.log ("useGetAllChannelsQuery",data)
  const [deleteChannel] = useDeleteChannelMutation();

  const videos = data?.data?.result || [];

  const filteredVideos = videos.filter((video) => {
    const searchContent = `
      ${video.title || ""}
      ${video.description || ""}
      ${video.channel?.name || ""}
    `.toLowerCase();
    return searchContent.includes(searchTerm.toLowerCase());
  });

  const confirmDelete = async () => {
    try {
      await deleteChannel(selectedVideoId).unwrap();
      toast.success("Video deleted successfully!");
      dispatch(closeDeleteModal());
      refetch();
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error("Failed to delete video. Try again.");
      dispatch(closeDeleteModal());
    }
  };

  return (
    <div className="p-6 relative">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold">Lista Chanle Youtube</h2>
        <button
          onClick={() => navigate("/admin/createchannel")}
          className="bg-orange-500 text-white px-4 py-2 rounded-full shadow-lg hover:bg-orange-600"
          title="Add new video"
        >
          +
        </button>
      </div>
      <div className="w-[28%] mb-4">
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => dispatch(setSearchTerm(e.target.value))}
          className="border p-2 w-full rounded"
        />
      </div>
      <div className="overflow-x-auto rounded border border-gray-200">
        <table className="w-full text-base text-left bg-white">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3">Thumbnail</th>
              {/* <th className="p-3">Title</th> */}
              <th className="p-3">Canale</th>
              <th className="p-3">Descrizione</th>
              <th className="p-3 text-center">Azione</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="5" className="p-4 text-center">
                  Sto caricando...
                </td>
              </tr>
            ) : filteredVideos.length > 0 ? (
              filteredVideos.map((video) => (
                <tr key={video.id} className="border-t">
                  <td className="p-3">
                    <img
                        src={video.coverThumbnail ? video.coverThumbnail : "https://placehold.co/400"}

                      alt="thumb"
                      className="w-20 h-auto rounded"
                    />
                  </td>
                  {/* <td className="p-3">{video.title}</td> */}
                  <td className="p-3">{video.type || "Youtube"}</td>
                  <td className="p-3">
                    {video.description?.slice(0, 100) || "-"}
                  </td>
                  <td className="p-3 flex gap-4 justify-evenly mt-5">
                   {video.id !=1 && <button
                      title="Delete"
                      onClick={() => dispatch(openDeleteModal(video.id))}
                      className="hover:text-red-500"
                    >
                      <FaTrash />
                    </button>}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="p-4 text-center text-gray-500">
                  No videos found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isDeleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md w-96 text-center">
            <h3 className="text-lg font-bold mb-4">Confirm Deletion</h3>
            <p>Are you sure you want to delete this video?</p>
            <div className="mt-6 flex justify-center gap-4">
              <button
                onClick={confirmDelete}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
              >
                Yes, Delete
              </button>
              <button
                onClick={() => dispatch(closeDeleteModal())}
                className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoList;
